module.exports = {
  ENDPOINTS: [
    {
      url: 'https://www.producthunt.com/feed?category=undefined',
      name: 'ProductHunt',
      homepage: 'https://www.producthunt.com'
    },
    {
      url: 'https://news.ycombinator.com/rss',
      name: 'HackerNews',
      homepage: 'https://news.ycombinator.com'
    },
    {
      url: 'https://www.designernews.co/?format=rss',
      name: 'DesignerNews',
      homepage: 'https://www.designernews.co'
    },
    {
      url: 'https://frontendfront.com/feed/stories',
      name: 'FrontEndFront',
      homepage: 'http://www.frontendfront.com/',
    },
    {
      url: 'http://www.echojs.com/rss',
      name: 'EchoJS',
      homepage: 'http://www.echojs.com/',
    },
    {
      url: 'https://lobste.rs/rss',
      name: 'Lobsters',
      homepage: 'https://lobste.rs/',
    }
  ]
}